/** 将管理后台所有可编辑控件标记为新密码用途，避免 Chrome 展示已记忆的表单值。 */
export function suppressBrowserAutocomplete(root: ParentNode = document): void {
    const formSelector = "form";
    const fieldSelector = 'input, textarea, select, [contenteditable="true"]';
    const forms = Array.from(root.querySelectorAll<HTMLFormElement>(formSelector));
    if (root instanceof Element && root.matches(formSelector)) {
        forms.unshift(root as HTMLFormElement);
    }
    // Chrome 也会按所属表单生成历史建议；只标记字段不足以约束 Form 包装的筛选项。
    forms.forEach(form => {
        if (form.getAttribute("autocomplete") !== "off") form.setAttribute("autocomplete", "off");
    });

    const fields = Array.from(root.querySelectorAll<HTMLElement>(fieldSelector));
    if (root instanceof Element && root.matches(fieldSelector)) fields.unshift(root as HTMLElement);
    fields.forEach(field => {
        // 搜索表单内由 Form.Item 生成的稳定 ID 会继续触发 Chrome 历史匹配；换成每个控件独有的 ID，并同步标签关联。
        if (
            field instanceof HTMLInputElement &&
            field.closest(".admin-table-filter-form") &&
            ["text", "search", "tel", "email", "url"].includes(field.type)
        ) {
            const managedId = field.dataset.browserAutocompleteManagedId;
            if (managedId) {
                if (field.id !== managedId) {
                    const previousId = field.id;
                    field.closest(".admin-table-filter-form")
                        ?.querySelectorAll<HTMLLabelElement>("label[for]")
                        .forEach(label => {
                            if (label.htmlFor === previousId) label.htmlFor = managedId;
                        });
                    field.id = managedId;
                }
            } else if (field.id) {
                const previousId = field.id;
                const uniqueId = `filter-field-${crypto.randomUUID()}`;
                field.closest(".admin-table-filter-form")
                    ?.querySelectorAll<HTMLLabelElement>("label[for]")
                    .forEach(label => {
                        if (label.htmlFor === previousId) label.htmlFor = uniqueId;
                    });
                field.dataset.browserAutocompleteManagedId = uniqueId;
                field.id = uniqueId;
            }
        }
        if (field.getAttribute("autocomplete") !== "new-password") field.setAttribute("autocomplete", "new-password");
    });
}

/** 安装全局输入监听，覆盖首屏字段及 Select 等组件后续创建的搜索输入框。 */
export function installBrowserAutocompletePolicy(root: HTMLElement = document.documentElement): () => void {
    suppressBrowserAutocomplete(root);

    const observer = new MutationObserver(records => {
        records.forEach(record => {
            // UI 组件可能在挂载后重写 autocomplete，属性变化也要重新应用策略。
            if (record.type === "attributes" && record.target instanceof HTMLElement) {
                suppressBrowserAutocomplete(record.target);
            }
            record.addedNodes.forEach(node => {
                if (node instanceof HTMLElement) suppressBrowserAutocomplete(node);
            });
        });
    });
    observer.observe(root, { attributes: true, attributeFilter: ["autocomplete", "id"], childList: true, subtree: true });

    return () => observer.disconnect();
}
